import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { Pill, Text } from "@src/appV2/redesign/system/ui-components";
import parachuteGiftImage from "@src/appV2/redesign/system/ui-components/illustrations/assets/parachute-gift.png";

interface CancellationProtectionBannerProps {
  onViewTerms: () => void;
  onDismiss: () => void;
}

export function CancellationProtectionBanner(props: CancellationProtectionBannerProps) {
  const { onViewTerms, onDismiss } = props;

  return (
    <Stack
      sx={(theme) => ({
        padding: theme.spacing(5),
        borderRadius: theme.borderRadius?.medium,
        background: theme.palette.cancellationProtection?.gradient,
        position: "relative",
        overflow: "hidden",
      })}
    >
      <Box
        component="img"
        src={parachuteGiftImage}
        alt=""
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          height: "80%",
          maxHeight: 96,
          aspectRatio: "1 / 1",
          objectFit: "contain",
          pointerEvents: "none",
          transform: "translate(-16%, -20%)",
        }}
      />
      <IconButton
        aria-label="Dismiss"
        iconType="close"
        size="small"
        variant="ghost"
        sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
        onClick={onDismiss}
      />
      <Pill
        label="Now live in your area"
        size="small"
        sx={{ alignSelf: "flex-start", position: "relative", marginRight: 8 }}
      />
      <Stack
        gap={5}
        sx={{ flex: 1, justifyContent: "space-between", marginTop: 2, position: "relative" }}
      >
        <Stack gap={3}>
          <Text bold variant="h4" sx={(theme) => ({ color: theme.palette.text.primary })}>
            Cancellation Protection
          </Text>
          <Text
            variant="body1"
            sx={{ color: (theme) => theme.palette.text.secondary, maxWidth: "75%" }}
          >
            Get your full earnings when a workplace cancels last minute.
          </Text>
        </Stack>
        <Button
          variant="contained"
          size="small"
          sx={{ alignSelf: "flex-start" }}
          onClick={onViewTerms}
        >
          View terms
        </Button>
      </Stack>
    </Stack>
  );
}
